import { ModuleWithProviders, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// import { MaterialModule } from './Material.module';
import { ToastrModule } from 'ngx-toastr';
//----------------------------Swal
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { BaseComponent } from './components/base.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { InputMaskAngularModule } from 'input-mask-angular';
import { UpdateImageComponent } from './components/controls/update-image/update-image.component';
import { ChangeUserPasswordComponent } from './components/controls/change-user-password/change-user-password.component';
import { AddWalkInCustomerComponent } from './components/controls/add-walkin-customer/add-walkin-customer.component';
import { EmployeeFilterPopupComponent } from './components/controls/employee-filter-popup/employee-filter-popup.component';
import { CustomerFilterPopupComponent } from './components/controls/customer-filter-popup/customer-filter-popup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MultiFileUploadComponent } from './components/controls/multi-file-upload/multi-file-upload.component';
import { AdditionalColumnsPopupComponent } from './components/controls/additional-columns-popup/additional-columns-popup.component';
import { AddUserComponent } from './components/controls/add-user/add-user.component';
import { AddCustomerComponent } from './components/controls/add-customer/add-customer.component';
//import { AngularEditorModule } from '@kolkov/angular-editor';
import { DatepickerModule } from 'ng2-datepicker';
import { CustomizeBillToPopupComponent } from './components/controls/customize-bill-to-popup/customize-bill-to-popup.component';
import { AssignUserPopupComponent } from './components/controls/assign-user-popup/assign-user-popup.component';
import { ConfirmActionPopupComponent } from './components/controls/confirm-action-popup/confirm-action-popup.component';
import { GeneralResultFormPopupComponent } from './components/controls/general-result-form-popup/general-result-form-popup.component';
import { WebcamModule } from 'ngx-webcam';
import { CustomDatePipline } from './customDatePipline.pipe';
import { OrderFilterPopupComponent } from './components/controls/order-filter-popup/order-filter-popup.component';
import { PayPopupComponent } from './components/controls/pay-popup/pay-popup.component';
import { HeaderComponent } from './customer-layout/header/header.component';
import { MobileMenuComponent } from './customer-layout/mobile-menu/mobile-menu.component';
import { PublicFooterComponent } from './customer-layout/footer/public-footer.component';
import { DateFilterPopupComponent } from './components/controls/date-filter-popup/date-filter-popup.component';
import { AddEditCategoryComponent } from './components/controls/add-edit-category/add-edit-category.component';
import { AddEditServiceComponent } from './components/controls/add-edit-service/add-edit-service.component';
import { AddEditImplementationComponent } from './components/controls/add-edit-implementation/add-edit-implementation.component';
import { AddEditReasonComponent } from './components/controls/add-edit-reason/add-edit-reason.component';
import { AddEditUserAssignmentComponent } from './components/controls/add-edit-user-assignment/add-edit-user-assignment.component';
import { OrderNotePopupComponent } from './components/controls/order-note-popup/order-note-popup.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { InquiryEditPopupComponent } from './components/controls/inquiry-edit-popup/inquiry-edit-popup.component';
import { AddEditReceiptTypeComponent } from './components/controls/add-edit-receipt-type/add-edit-receipt-type.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PaymentGatewayPopupComponent } from './components/controls/payment-gateway-popup/payment-gateway-popup.component';
import { UploadAttachmentNoticePopupComponent } from './components/controls/upload-attachment-notice-popup/upload-attachment-notice-popup.component';
import { DashboardMenuComponent } from './dashboard-menu/dashboard-menu.component';
import { OrderRejectionPopupComponent } from './components/controls/order-rejection-popup/order-rejection-popup.component';
import { RdcResultFormComponent } from './components/controls/rdc-result-form/rdc-result-form.component';
import { RdcPrimaryDataFilterPopupComponent } from './components/controls/rdc-primary-data-filter-popup/rdc-primary-data-filter-popup.component';
//import { NoticeComponent } from './components/controls/notice/notice.component';

@NgModule({
    declarations: [
        BaseComponent,
        UpdateImageComponent,
        ChangeUserPasswordComponent,
        AddWalkInCustomerComponent,
        EmployeeFilterPopupComponent,
        MultiFileUploadComponent,
        AdditionalColumnsPopupComponent,
        AddUserComponent,
        AddCustomerComponent,
        CustomerFilterPopupComponent,
        CustomizeBillToPopupComponent,
        AssignUserPopupComponent,
        ConfirmActionPopupComponent,
        GeneralResultFormPopupComponent,
        CustomDatePipline,
        OrderFilterPopupComponent,
        PayPopupComponent,
        HeaderComponent,
        MobileMenuComponent,
        PublicFooterComponent,
        DateFilterPopupComponent,
        AddEditCategoryComponent,
        AddEditServiceComponent,
        AddEditImplementationComponent,
        AddEditReasonComponent,
        AddEditReceiptTypeComponent,
        AddEditUserAssignmentComponent,
        OrderNotePopupComponent,
        InquiryEditPopupComponent,
        PaymentGatewayPopupComponent,
        UploadAttachmentNoticePopupComponent,
        DashboardMenuComponent,
        OrderRejectionPopupComponent,
        RdcResultFormComponent,
        RdcPrimaryDataFilterPopupComponent,
        //NoticeComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        NgbModule,
        CdkStepperModule,
        InputMaskAngularModule,
        NgSelectModule,
        DatepickerModule,
        WebcamModule,
        SignaturePadModule,
        NgMultiSelectDropDownModule.forRoot()
    ],
    exports: [
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        SweetAlert2Module,
        TranslateModule,
        ToastrModule,
        BaseComponent,
        NgbModule,
        AgmCoreModule,
        CdkStepperModule,
        InputMaskAngularModule,
        NgSelectModule,
        MultiFileUploadComponent,
        DatepickerModule,
        WebcamModule,
        CustomDatePipline,
        HeaderComponent,
        PublicFooterComponent,
        SignaturePadModule,
        NgMultiSelectDropDownModule,
        DashboardMenuComponent
    ],
    providers: [],
    schemas: [
      NO_ERRORS_SCHEMA
    ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule
    };
  }
}
